<template>
    <div>
        <v-container style="max-width: 1300px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 1rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Carga Horaria
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1"
                style="margin-bottom: 2rem !important;padding: 2rem .6rem 0 .6rem;">
                <v-row>
                    <v-col cols="12" lg="3" md="4">
                        <v-text-field max-width="200" class="mx-3" v-model="searchNombre" label="Nombre"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="4">
                        <v-text-field max-width="200" class="mx-3" v-model="searchArea" label="Área"
                            append-icon="mdi-magnify" outlined dense>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="3">
                        <v-select v-model="searchPeriodo" :items="arrayPeriodos" item-text="periodo"
                            item-value="periodo" label="Periodo" outlined dense>
                        </v-select>
                    </v-col>
                    <v-col cols="12" lg="3" md="4" v-if="searchPeriodo !== null">
                        <el-button type="primary" @click="openCargaMasiva">Carga Masiva</el-button>
                    </v-col>
                </v-row>
            </v-card>
            <v-card v-if="searchPeriodo !== null" class="mx-auto my-5"
                style=" margin:0 auto;padding: 1.5rem;">
                <div>
                    <v-data-table :headers="filteredHeaders" :items="filteredData" :loading="isLoading" dense
                        loading-text="Cargando... Por favor espere" style="margin: 0 auto;">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top color="teal" v-if="item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark @click="openEdit(item)" color="teal"
                                        v-bind="attrs" v-on="on">
                                        <v-icon class="custom-icon" dark>
                                            mdi-timetable
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Carga Horaria</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.estado`]="{ item }">
                            <span :class="item.estado ? 'activo' : 'desactivado'">
                                {{ item.estado ? 'Activo' : 'Desactivado' }}
                            </span>
                        </template>

                    </v-data-table>
                </div>
            </v-card>
            <el-dialog :title="titleForm" :visible.sync="dialogEdit">
                <el-form :model="usuarioForm" label-position="top">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <el-form-item label="Nombres" :label-width="formLabelWidth">
                                <el-input v-model="usuarioForm.nombre" autocomplete="off"></el-input>
                            </el-form-item>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <el-form-item label="Usuario" :label-width="formLabelWidth">
                                <el-select v-model="usuarioForm.usuario_id" filterable placeholder="Select"
                                    style="width: 100%;">
                                    <el-option v-for="item in dataUsuariosHisar" :key="item.idUsuario"
                                        :label="item.nombre" :value="item.idUsuario">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <el-form-item label="Correo" :label-width="formLabelWidth">
                                <el-input v-model="usuarioForm.correo" autocomplete="off"></el-input>
                            </el-form-item>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <el-form-item label="Rol" :label-width="formLabelWidth">
                                <el-select v-model="usuarioForm.rol_id" filterable placeholder="Select"
                                    style="width: 100%;">
                                    <el-option v-for="item in arrayRoles" :key="item.id" :label="item.nombre"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <el-form-item label="Área" :label-width="formLabelWidth">
                                <el-select v-model="usuarioForm.area_id" filterable placeholder="Select"
                                    style="width: 100%;">
                                    <el-option v-for="item in arrayAreas" :key="item.id" :label="item.nombre"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </v-col>
                    </v-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeEdit">Cancelar</el-button>
                    <el-button type="primary" @click="save" v-if="!statusEdit">Confirmar</el-button>
                    <el-button type="primary" @click="edit" v-if="statusEdit">Guardar</el-button>
                </span>
            </el-dialog>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
            <el-dialog :title="titleForm" :visible.sync="dialogCargaSimple" persistent
                @closed="destruirComponenteDias" @open="abrirComponenteDias">
                <CargaSimple v-if="mostrarDias" :periodoActual="periodoActual"
                    @closeDialogCargaSimple="closeDialogCargaSimple" :personalActual="personalActual"></CargaSimple>
            </el-dialog>
            <el-dialog :title="titleForm" :visible.sync="dialogCargaMasiva" persistent 
                @closed="destruirComponenteDias" @open="abrirComponenteDias">
                <CargaMasiva v-if="mostrarDias" :periodoActual="periodoActual"
                    @closeDialogCargaMasiva="closeDialogCargaMasiva"></CargaMasiva>
            </el-dialog>
        </v-container>
    </div>
</template>
<style scoped>
.el-form-item__label {
    line-height: 0px !important;
}
::v-deep .el-dialog {
    width: 75%;
    margin-top: 3% !important;
    margin-bottom: 3% !important;
}
.activo {
    color: rgb(255, 255, 255);
    background: #74d467;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

.desactivado {
    color: rgb(255, 255, 255);
    background: #df4141;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

::v-deep .theme--dark.v-system-bar {
    color: hsl(0, 0%, 100%) !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 25px !important;
    height: 25px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
import CargaSimple from "./carga_simple.vue";
import CargaMasiva from "./carga_masiva.vue";
export default {
    data() {
        return {
            mostrarDias: true,
            periodoActual: null,
            dialogCargaMasiva:false,
            dialogCargaSimple: false,
            arrayPeriodos: [],
            titleForm: 'Carga Horaria Masiva',
            formLabelWidth: '70px',
            valid: true,
            idUsuario: null,
            titleButton: 'Guardar',
            usuarioForm: {
                usuario_id: null,
                nombre: null,
                correo: null,
                rol_id: null,
                area_id: null
            },
            searchSala: [],
            statusEdit: false,
            modal: false,
            searchNombre: null,
            searchRol: null,
            searchArea: null,
            dialogImport: false,
            dialogLoader: false,
            ver: false,
            searchDocumento: "",
            dataPaciente: [],
            dataEnvio: {
                fecha: null,
            },
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Código Planilla", value: "cod_planilla" },
                { text: "Nombres Completos", value: "nombre_completo" },
                { text: "Cargo", value: "cargo" },
                { text: "Descripción de Cargo", value: "descripcion_cargo", align: "center" },
                { text: "Condición de Ingreso", value: "cond_ingreso" },
                { text: "Estado", value: "estado" },
                { text: "Acciones", value: "actions", align: "right" }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            menu: false,
            idItem: null,
            itemMes: null,
            itemPeriodo: null,
            dataArray: [],
            arrayAreas: [],
            arrayRoles: [],
            dataUsuariosHisar: [],
            searchPeriodo: null,
            personalActual: null,
            idSystem:null,
        };
    },
    watch: {
        dialogEdit(newVal, oldVal) {
            if (newVal) {
                console.log("El diálogo se abrió.asda");
            } else {
                this.closeEdit();
                this.periodoActual = null;
            }
        },
        dialogCargaSimple(newVal, oldVal) {
            if (newVal) {
                console.log("El diálogo se abrió.");
            } else {

            }
        },
    },
    methods: {
        closeDialogCargaMasiva(){
            this.dialogCargaMasiva = false;
        },
        closeDialogCargaSimple() {
            this.dialogCargaSimple = false;
        },
        destruirComponenteDias() {
            this.mostrarDias = false; // desmonta el componente
        },
        abrirComponenteDias() {
            this.mostrarDias = true;
        },
        loadPeriodos() {
            axios
                .get(RUTA_API + "/rrhh_planilla_periodos/")
                .then((res) => {
                    this.arrayPeriodos = res.data;
                })
                .catch((res) => {
                    this.dialog = false;
                });
        },
        loadUsuarioHisar() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/usuarioIndex/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataUsuariosHisar = res.data;
                            this.dataUsuariosHisar.forEach((item) => {
                                // Calcula el nombre completo y guárdalo en una nueva propiedad 'nombreCompleto'
                                item.idUsuario = parseInt(item.url.split("/")[4], 10);
                            });
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        clearForm() {
            this.usuarioForm = {
                nombre: null,
                correo: null,
                rol_id: null,
                area_id: null,
                usuario_id: null
            }
        },
        loadRoles() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/seguridad_roles/listar-rol/?system="+this.idSystem, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayRoles = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadAreas() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/seguridad_area/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayAreas = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        openCargaMasiva(){
            this.titleForm = 'Carga Horaria Masiva - Periodo : ' + this.searchPeriodo;
            /* this.statusEdit = true; */
            this.periodoActual = this.searchPeriodo;
            this.dialogCargaMasiva= true;
        },
        openEdit(item) {
            this.titleForm = 'Carga Horaria Simple - Periodo : ' + this.searchPeriodo;
            this.statusEdit = true;
            this.personalActual = item;
            this.periodoActual = this.searchPeriodo;
            this.idUsuario = item.id;
            this.dialogCargaSimple = true;
        },
        closeEdit() {
            this.statusEdit = false;
            this.dialogEdit = false;
            this.titleForm = 'Carga Horaria Masiva';
            this.clearForm();
        },
        save() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/seguridad_usuario/", {
                            area_id: this.usuarioForm.area_id,
                            correo: this.usuarioForm.correo,
                            nombre: this.usuarioForm.nombre,
                            rol_id: this.usuarioForm.rol_id,
                            usuario_id: this.usuarioForm.usuario_id
                        }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El usuario se registró con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.dialogEdit = false;
                            this.dataInit();
                            this.dialogLoader = false;
                            this.clearForm();
                            this.statusEdit = false;

                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        edit() {
            this.dialogLoader = true;
            this.statusEdit = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .put(RUTA_API + "/seguridad_usuario/" + this.idUsuario + "/", this.usuarioForm, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El usuario se editó con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.clearForm();
                            this.dialogEdit = false;
                            this.dataInit();
                            this.dialogLoader = false;
                            this.statusEdit = false;

                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/rrhh_planilla_personal/?estado=true&campos=id,estado,nombre_completo,cod_planilla,cond_ingreso,cargo,descripcion_cargo", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },
        filteredData() {
            if (!this.searchNombre && !this.searchArea) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchNombre) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.nombre;
                    return nombreCompleto.toLowerCase().includes(this.searchNombre.toLowerCase());
                });
            }
            if (this.searchArea) {
                filtered = filtered.filter((item) =>
                    item.area
                        .toLowerCase()
                        .includes(this.searchArea.toLowerCase())
                );
            }
            return filtered;
        },
    },
    created() {
        this.loadUsuarioHisar();
        this.loadAreas();
        this.loadRoles();
        this.dataInit();
        this.loadPeriodos();
        this.idSystem=sessionStorage.getItem("idSystem");
    },
    components: {
        CargaSimple,
        CargaMasiva
    },
};
</script>